// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 402 ? "product-capability" : chunkId) + ".chunk." + {"329":"4ef61d","402":"73dcfd"}[chunkId] + ".js";
};